import { Fragment } from "react";
import { BeatLoader } from "react-spinners";

const BeatSpinner = () => {
  return (
    <Fragment>
      <BeatLoader color="white" />
    </Fragment>
  );
};

export default BeatSpinner;
